module.exports = __webpack_public_path__ + "static/media/logout.5df9450e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/ProfileMenu/logout.svg
// module id = 1423
// module chunks = 0